// removed by extract-text-webpack-plugin
module.exports = {"PlaceholderDefaultColor":"#d8d8d8","PlaceholderDarkGrey":"#8e8e8e","EmployeeTile":"EmployeeTile-my95ff6z3n691j79s8r5cj53dpvswt6nty8jdv2fqnuqzu6es12fxsxz2axewznbyhndwcmsgkmh1ut57dh54rk3vfbqnrg5vfv5nq","Avatar":"Avatar-4c33bv4vx8wctp61tbnxvc6jft3gkx2p5zybj78urf3yhysbccw663e8ts2qgp8enp6m5zkhq6yawhpyummb3vgxhxgsua9q4bq31qz","loading":"loading-dhp2pzktc4ag1b9684w5s3pbjuu8mphd3nqqjfvj51f6txawwtx1n3w9ysdtkc6q61drsffwcnhcrmf4xe7qxps26p8jv7x7ewa7em","pulse":"pulse-4jpwxs5ks7my3aazjqzdspzsffvj42wcwq3zd7x232tmamyp5cmeeu23xcfsp3mrsxrbe7rbp3g9hjjbfmpbhbksmc9cvgtk56nhr6c"};


//////////////////
// WEBPACK FOOTER
// ./src/views/TeamOfExperts/components/EmployeeTile/EmployeeTile.module.scss
// module id = 1335
// module chunks = 0